import { IPlayerStateHandler } from '../interfaces-and-types';

export type PlaybackState = {
    isStuck: boolean,
    stuckTimestamp: number
}

export default class PlaybackStateHandler implements IPlayerStateHandler {
    private isStuck = false;

    private stuckTimestamp = -Infinity;

    public setState(partial: Partial<PlaybackState>): Partial<PlaybackState> {
        if (partial.isStuck === undefined) {
            return this.state;
        }

        this.isStuck = partial.isStuck;
        this.stuckTimestamp = Date.now();

        return this.state;
    }

    // getters

    public get state(): PlaybackState {
        return {
            isStuck: this.isStuck,
            stuckTimestamp: this.stuckTimestamp
        };
    }
}
